import React, { useContext, useMemo } from "react";

import useToggleState from "hooks/useToggleState";

const UIContext = React.createContext({});

export const UIContextProvider = ({ children }) => {
  const { toggle: toggleAdminBarOpened, value: adminBarOpened } = useToggleState(false);
  const contextValue = useMemo(
    () => ({
      toggleAdminBarOpened,
      adminBarOpened,
    }),
    [adminBarOpened, toggleAdminBarOpened],
  );

  return <UIContext.Provider value={contextValue}>{children}</UIContext.Provider>;
};

const useUIContext = () => useContext(UIContext);
export default useUIContext;
